import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { MenuRoute } from '../routes/menuRoutes'
import menuRouteUtil from '../utils/menuRoute.util'
import DivLink from './DivLink'
import Icon from './Icon'

export interface MenuItemProps
    extends Pick<MenuRoute, 'text' | 'icon' | 'to'> {
    /**
     * The menu group's own path, when `to` has been redirected to a
     * permitted child route. Highlighting is keyed on the group, not the
     * target.
     */
    groupPath?: string
    onRoute: (to?: string) => void
}

export default class MenuItem extends Component<MenuItemProps> {
  constructor (props: MenuItemProps) {
    super(props)
    this.isActive = this.isActive.bind(this)
  }

  isActive (match: any, location: any) {
    const groupPath = this.props.groupPath || this.props.to
    return menuRouteUtil.isGroupPath(groupPath, location.pathname)
  }

  handleRoute = () => {
    this.props.onRoute(this.props.to)
  }

  render () {
    return this.props.icon &&
            <NavLink
                exact={true}
                to={this.props.to}
                className="mb-2 px-1"
                isActive={this.isActive}
                activeClassName="bg-orange-400">
                <DivLink
                    to={this.props.to}
                    className='flex flex-col items-center'
                    onClick={this.handleRoute}>
                    <Icon
                        name={this.props.icon}
                        className="flex justify-center items-center h-9 w-9"
                        size="large"
                        color="white"/>
                    <p className="text-white text-xm">
                        {this.props.text}
                    </p>
                </DivLink>
            </NavLink>
  }
}
